import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.quotas');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-quotas',
template: templateSource || '',
    styles: [`

/* file: /Users/ijaemun/Documents/Codex/2026-09-30/task/migration-prep/mac-candidate-build/src/app/page.admin.quotas/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 0;
}

.quota-page,
.quota-table-wrap {
  min-width: 0;
}

.quota-page input[type=number] {
  font-variant-numeric: tabular-nums;
}

@media (max-width: 767px) {
  .quota-header {
    padding: 14px 12px;
  }
  .quota-table-wrap {
    -webkit-overflow-scrolling: touch;
  }
}`],
})
export class PageAdminQuotasComponent implements OnInit {
    public users: any[] = [];
    public summary: any = {};
    public defaults: any = {};
    public query: string = '';
    public loading: boolean = true;
    public savingUserId: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (
            this.service.auth.session?.role !== 'admin'
            || this.service.auth.session?.quota_enabled === false
        ) {
            this.service.href('/chatbot');
            return;
        }
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();
        try {
            const res: any = await wiz.call('load', { query: this.query.trim() });
            if (res.code === 200) {
                this.users = res.data?.users || [];
                this.summary = res.data?.summary || {};
                this.defaults = res.data?.defaults || {};
            } else {
                await this.showError(res.data?.message || '할당량 정보를 불러오지 못했습니다.');
            }
        } catch (e: any) {
            await this.showError(e?.message || '할당량 정보를 불러오지 못했습니다.');
        }
        this.loading = false;
        await this.service.render();
    }

    public async search(event?: Event) {
        if (event) event.preventDefault();
        await this.load();
    }

    public async clearSearch() {
        this.query = '';
        await this.load();
    }

    private normalizeLimit(value: any): number {
        const parsed = Number(value);
        if (!Number.isFinite(parsed)) return 0;
        return Math.min(1000000, Math.max(0, Math.floor(parsed)));
    }

    public normalizeRow(row: any) {
        row.daily_session_limit = this.normalizeLimit(row.daily_session_limit);
        row.session_question_limit = this.normalizeLimit(row.session_question_limit);
    }

    public async save(row: any) {
        if (!row?.id || this.savingUserId) return;
        this.normalizeRow(row);
        this.savingUserId = row.id;
        await this.service.render();
        try {
            const res: any = await wiz.call('save_quota', {
                id: row.id,
                daily_session_limit: row.daily_session_limit,
                session_question_limit: row.session_question_limit,
            });
            if (res.code === 200 && res.data?.user) {
                Object.assign(row, res.data.user);
                this.savingUserId = '';
                await this.service.modal.show({
                    title: '저장 완료',
                    message: `${row.name || row.email} 사용자의 할당량을 저장했습니다.`,
                    action: '확인',
                    cancel: false,
                    status: 'success',
                });
                await this.load();
                return;
            }
            await this.showError(res.data?.message || '할당량을 저장하지 못했습니다.');
        } catch (e: any) {
            await this.showError(e?.message || '할당량을 저장하지 못했습니다.');
        }
        this.savingUserId = '';
        await this.service.render();
    }

    public isSaving(row: any): boolean {
        return this.savingUserId === row?.id;
    }

    public dailyUsageText(row: any): string {
        const used = Number(row?.daily_session_used || 0);
        const limit = Number(row?.daily_session_limit || 0);
        const remaining = Math.max(0, limit - used);
        return limit > 0
            ? `사용 ${used}개 · 남음 ${remaining}개`
            : `사용 ${used}개 · 남음 무제한`;
    }

    public questionUsageText(row: any): string {
        const used = Number(row?.max_session_question_used || 0);
        const limit = Number(row?.session_question_limit || 0);
        const remaining = Math.max(0, limit - used);
        return limit > 0
            ? `최대 사용 ${used}개 · 남음 ${remaining}개`
            : `최대 사용 ${used}개 · 남음 무제한`;
    }

    public statusText(row: any): string {
        if (row?.daily_blocked && row?.question_blocked) return '모두 도달';
        if (row?.daily_blocked) return '세션 한도 도달';
        if (row?.question_blocked) return '질문 한도 도달';
        if (!row?.limited) return '무제한';
        return '사용 가능';
    }

    public statusClass(row: any): string {
        if (row?.daily_blocked || row?.question_blocked) return 'bg-red-50 text-red-600 border-red-200';
        if (!row?.limited) return 'bg-slate-50 text-slate-500 border-slate-200';
        return 'bg-emerald-50 text-emerald-600 border-emerald-200';
    }

    public trackByUser(_index: number, row: any): string {
        return row?.id || String(_index);
    }

    private async showError(message: string) {
        await this.service.modal.show({
            title: '오류',
            message,
            action: '확인',
            cancel: false,
            status: 'error',
        });
    }
}

export default PageAdminQuotasComponent;